import { SvgIcon, SvgIconProps } from "@mui/material";
import { FC } from "react";

const HomeIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 28 25">
      <path d="M12.9995 1.28125C13.4213 0.953125 14.0307 0.953125 14.4526 1.28125L26.8276 11.7812C27.2963 12.2031 27.3432 12.9062 26.9682 13.375C26.5463 13.8438 25.8432 13.8906 25.3745 13.5156L24.2495 12.5312V21.25C24.2495 23.3594 22.562 25 20.4995 25H6.99945C4.89008 25 3.24945 23.3594 3.24945 21.25V12.5312L2.07758 13.5156C1.60883 13.8906 0.905704 13.8438 0.483829 13.375C0.108829 12.9062 0.155704 12.2031 0.624454 11.7812L12.9995 1.28125ZM5.49945 10.6094V21.25C5.49945 22.0938 6.1557 22.75 6.99945 22.75H20.4995C21.2963 22.75 21.9995 22.0938 21.9995 21.25V10.6094L13.7495 3.625L5.49945 10.6094Z" />
    </SvgIcon>
  );
};

export default HomeIcon;
